/**
 * The response chart's measurements, shared by the plot, the overlays drawn on
 * top of it and the viewport hook that turns pixels into time.
 *
 * They live apart from the components because four things have to agree on
 * them to the pixel: recharts draws its plot area inside these margins, the
 * status lane and the edge fades sit over that same area as plain divs, and
 * the viewport hook works out how many milliseconds one pixel is from the
 * plot's width. One number changed in one place only, and the red lane stands
 * a few pixels off the outage it marks.
 */

/** The y axis' width. Wide enough for "1,2 s" and "600 ms" on one line; narrower and the unit wraps. */
export const PLOT_LEFT = 64;
/** Room right of the plot, so the last x label is not cut in half. */
export const PLOT_RIGHT = 8;
/** Room above the plot for the top y label. */
export const PLOT_TOP = 8;
/** The x axis under the plot: the status lane, then the tick labels. */
export const X_AXIS_HEIGHT = 34;
/** Recharts starts a bottom label at 6 px (its tick size, drawn or not) plus this under the
 *  plot, so the labels clear the lane: 14 px down, the lane ends at 11. */
export const X_TICK_MARGIN = 8;
/** The status lane's height and its gap from the plot. */
export const LANE_HEIGHT = 8;
export const LANE_GAP = 3;
/** The lane's distance from the chart's bottom edge, so it sits right under the plot at any height. */
export const LANE_BOTTOM = X_AXIS_HEIGHT - LANE_GAP - LANE_HEIGHT;
/** How wide the fade over a side that can still be scrolled is. */
export const FADE_WIDTH = 40;
/** The overview of the whole history under the chart. */
export const NAVIGATOR_HEIGHT = 40;

/** The plot area's width inside a frame this wide. */
export function plotWidthOf(frameWidth: number): number {
  return Math.max(0, frameWidth - PLOT_LEFT - PLOT_RIGHT);
}
